/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_QUERY = "ON_QUERY";
export const ON_FORZAR_DNE = "ON_FORZAR_DNE";
export const ON_LANDING = "ON_LANDING";
export const ON_OFFER = "ON_OFFER";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_SEARCH_ENCOTESA = "ON_SEARCH_ENCOTESA";
export const ON_CONFIRMAR_RENAPER = "ON_CONFIRMAR_RENAPER";
export const ON_CONFIRMAR_RENAPER_FLAG = "ON_CONFIRMAR_RENAPER_FLAG";
export const ON_PASO_2 = "ON_PASO_2";
export const ON_PASO_3 = "ON_PASO_3";
export const ON_PASO_4 = "ON_PASO_4";
export const ON_OTRO_DOMICILIO = "ON_OTRO_DOMICILIO";
export const ON_MODIFICAR_DOMICILIO = "ON_MODIFICAR_DOMICILIO";
export const ON_NORMALIZAR_DOMICILIO_PART = "ON_NORMALIZAR_DOMICILIO_PART";
export const ON_NORMALIZAR_DOMICILIO_ALTE = "ON_NORMALIZAR_DOMICILIO_ALTE";
export const ON_SUCURSAL = "ON_SUCURSAL";
export const ON_SOCIAL_NET_STATUS = "ON_SOCIAL_NET_STATUS";
export const ON_GRACIAS = "ON_GRACIAS";
export const ON_GRACIAS_GTM = "ON_GRACIAS_GTM";
export const ADOBE_APP_ON_CLICK_START = "ADOBE_APP_ON_CLICK_START";
export const ON_INGRESO_BANCA_ONLINE = "ON_INGRESO_BANCA_ONLINE";
export const ON_GRACIAS_CA = "ON_GRACIAS_CA";
export const ON_SOLICITAR_TURNO = "ON_SOLICITAR_TURNO";
export const ADOBE_ON_CLICK_TRACKING = "ADOBE_ON_CLICK_TRACKING";
export const ADOBE_APP_STARTED = "ADOBE_APP_STARTED";
export const ON_MOCK = "ON_MOCK";
export const ON_OPEN_MODAL = "ON_OPEN_MODAL";
export const ON_NOTIFICATION_TOAST = "ON_NOTIFICATION_TOAST";
export const onSelectEncotesaAlternativo = "onSelectEncotesaAlternativo";
export const onSelectEncotesaParticular = "onSelectEncotesaParticular";
export const onTCode = "onTCode";
export const ON_USER_TOKENIZADO = "ON_USER_TOKENIZADO";
export const ON_DEVICEID = "ON_DEVICEID";
export const ON_DEVICEIDTIMESTAMP = "ON_DEVICEIDTIMESTAMP";
export const ON_ADOBE_TARGET_EXPERIENCE = "ON_ADOBE_TARGET_EXPERIENCE";
export const ON_DOMICILIO = "ON_DOMICILIO";
export const ON_CONSULTA = "ON_CONSULTA";
export const ON_OFERTA = "ON_OFERTA";
export const ON_DATOS_PERSONALES = "ON_DATOS_PERSONALES";
export const ON_VALIDANDO_DOMICILIO = "ON_VALIDANDO_DOMICILIO";
export const ON_SUCURSALES = "ON_SUCURSALES";
export const ON_DATOS_LABORALES = "ON_DATOS_LABORALES";
export const ON_INFORMACION_ADICIONAL = "ON_INFORMACION_ADICIONAL";
export const ON_CLICK_CTA = "ON_CLICK_CTA";
export const ON_VERIDAS_EVENT = "ON_VERIDAS_EVENT";
export const ON_THANKS_VERIDAS = "ON_THANKS_VERIDAS";
export const ON_DIGITAL_PRESENCIAL = "ON_DIGITAL_PRESENCIAL";
export const ON_RESULT_VERIDAS = "ON_RESULT_VERIDAS";
export const ON_SAVE_IFRAME = "ON_SAVE_IFRAME";
export const SET_DVS_IFRAME_DATA = "SET_DVS_IFRAME_DATA";
export const RESET_DVS_IFRAME_DATA = "RESET_DVS_IFRAME_DATA";
export const ON_PRELOAD_SDK = "ON_PRELOAD_SDK";
export const ON_ERROR = "ON_ERROR";
export const ON_ERROR_VERIDAS = "ON_ERROR_VERIDAS";
export const ON_IS_VISIBLE_SDK = "ON_IS_VISIBLE_SDK";
export const ON_DATA_AUTH_ASO = "ON_DATA_AUTH_ASO";
export const ON_FUNNEL_ERROR = "ON_FUNNEL_ERROR";
export const ON_LOGIN = "ON_LOGIN";
export const ON_BIOMETRIA_POSITIVO = "ON_BIOMETRIA_POSITIVO";
export const ON_CONFIGURACION = "ON_CONFIGURACION";
export const ON_CONTRATACION = "ON_CONTRATACION";
export const ON_HUELLA_AVANZADA = "ON_HUELLA_AVANZADA";
export const ON_CONSULTA_CONTRATO = "ON_CONSULTA_CONTRATO";
export const ON_CONTRATO = "ON_CONTRATO";
export const ON_FIRMA_CONTRATOS = "ON_FIRMA_CONTRATOS";
export const ON_SEGMENTO_SCORE_CLIENTE = "ON_SEGMENTO_SCORE_CLIENTE";
export const ON_CUENTA = "ON_CUENTA";
export const ON_NORMALIZAR_CELULAR = "ON_NORMALIZAR_CELULAR";
export const ON_OTP_ERROR = "ON_OTP_ERROR";
export const ON_CELULAR = "ON_CELULAR";
export const ON_OTP_ONE = "ON_OTP_ONE";
export const ON_USUARIO_CLAVE = "ON_USUARIO_CLAVE";
export const ON_INTERNAL_LINK = "ON_INTERNAL_LINK";
